import { Component, inject, Input } from '@angular/core';
import { ModalService } from '@core/services';

@Component({
  standalone: false,
  selector: 'hm-filters-panel-header',
  templateUrl: './filters-panel-header.component.html',
  styleUrls: ['./filters-panel-header.component.scss'],
})
export class FiltersPanelHeaderComponent {
  @Input() headerTitle!: string;

  private readonly modalService = inject(ModalService);

  close(): void {
    this.modalService.close();
  }
}
